import { Avatar, useTheme } from '@mui/material'
import { CircularImage, isNotNullOrUndefined } from 'ComponentLibrary'

export const ImageAvatar = ({
    imageUrl,
    fallbackImageUrl,
    alt = 'user profile image',
    size,
}: {
    imageUrl?: string
    fallbackImageUrl?: string
    alt?: string
    size?: `${number}px`
}) => {
    const theme = useTheme()
    return (
        <Avatar
            sx={{
                backgroundColor: theme.palette.white,
                border: `1px solid ${theme.palette.customtext.black10}`,
                fontWeight: '500',
                scale: 0.8,
                height: size,
                width: size,
            }}
        >
            <CircularImage
                width="100%"
                height="100%"
                src={imageUrl}
                fallbackImageSrc={[fallbackImageUrl].filter(isNotNullOrUndefined)}
                alt={alt}
            />
        </Avatar>
    )
}

export default ImageAvatar
